const AssistantIcon = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.723 7.39 5.7 4.456h1.265l.978 2.934 2.933.978v1.265l-2.933.978-.978 2.934H5.7l-.978-2.934-2.934-.978V8.368l2.934-.978Zm1.61-.615-.45 1.353-.422.422L4.108 9l1.353.451.421.422.451 1.353.451-1.353.422-.422 1.352-.45-1.352-.451-.422-.422-.45-1.353ZM10.767 3.434l.52-1.56h.759l.52 1.56 1.56.52v.76l-1.56.52-.52 1.56h-.759l-.52-1.56-1.56-.52v-.76l1.56-.52Z"
      clipRule="evenodd"
    />
  </svg>
)
export default AssistantIcon